"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditCreditSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _typography = require("@creditas-lab/typography");

var _utils = require("../../utils");

var _constants = require("../../constants");

var _services = require("../../services");

var _Stepper = require("../Stepper");

var _EditCreditSection = require("./EditCreditSection.style");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes.number.isRequired
} : {};

const EditCreditSection = ({
  value
}) => {
  const {
    goTo
  } = (0, _Stepper.useStepper)();

  const handleEditClick = () => {
    (0, _services.dispatchEditCreditButtonClickEvent)();
    goTo(_constants.Steps.IntendedCredit);
  };

  return (0, _core.jsx)(_EditCreditSection.Container, null, (0, _core.jsx)(_EditCreditSection.AmountContainer, null, (0, _core.jsx)(_EditCreditSection.Label, {
    desktop: "md",
    mobile: "sm",
    color: "neutral60",
    weigth: "sm"
  }, "De quanto voc\xEA precisa?"), (0, _core.jsx)(_typography.Typography, {
    desktop: "xl",
    mobile: "lg",
    color: "neutral90",
    weigth: "sm"
  }, (0, _utils.formatCurrency)(value))), (0, _core.jsx)(_EditCreditSection.EditButton, {
    onClick: handleEditClick,
    "data-testid": "edit-amount-button"
  }, "Editar"));
};

exports.EditCreditSection = EditCreditSection;
process.env.NODE_ENV !== "production" ? EditCreditSection.propTypes = propTypes : void 0;
EditCreditSection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EditCreditSection",
  "props": {
    "value": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    }
  }
};